module.exports = __webpack_public_path__ + "static/media/land-banner.ea96c935.png";